import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  helpPageSearchPlaceHolder: {
    id: 'help.helpPageSearchPlaceHolder',
    defaultMessage: 'Search help'
  },
  helpPageTile: {
    id: 'help.Title',
    defaultMessage: 'Help'
  },
  helpPageSubTile: {
    id: 'help.helpPageSubTile',
    defaultMessage: 'Featured help'
  },
  helpSubtext: {
    id: 'help.helpSubtext',
    defaultMessage: 'Here are some helpful videos to get you started'
  },
  helpPara: {
    id: 'help.helpPara',
    defaultMessage: 'Here are a few useful help videos you can refer to understand the functionality of each of the pages ECIF Workscope.'
  },
  helpParaLinkInfo: {
    id: 'help.helpPara',
    defaultMessage: 'For more information and FAQs, please refer to the'
  },
  quickStartGuide: {
    id: 'help.quickStartGuide',
    defaultMessage: 'Quick Start Guide'
  },
  milestoneUploadFeature: {
    id: 'help.milestoneUploadFeature',
    defaultMessage: 'Milestone Upload Feature'
  },
  linkHereText: {
    id: 'help.linkHereText',
    defaultMessage: 'Wiki'
  },
  supplierCollaboration: {
    id: 'help.supplierCollaboration',
    defaultMessage: 'Supplier Collaboration'
  },
  applicationwalkthrough: {
    id: 'help.applicationwalkthrough',
    defaultMessage: 'Application Walkthrough'
  },
   globalEcifWalkthrough: {
    id: 'help.globalEcifWalkthrough',
    defaultMessage: 'Global ECIF Walkthrough'
  },
   ECIFQualityService: {
    id: 'help.ECIFQualityService',
    defaultMessage: 'ECIF Quality Service'
  }
});

